











































































import { Component, Emit, Vue } from 'vue-property-decorator';
import { demoServer, yunnanDataViewServer } from '@/api/installServer';
import PagingUnit from '@/components/paging/paging.vue';
import { TableStripe } from '@/mixins/tableStripe';
import TaskAbnormalDialog from './box-5-unit-3.vue';
import TaskAbnormalPointDialog from './box-5-unit-4.vue';
import Dayjs from 'dayjs';

@Component({
  components: { PagingUnit, TaskAbnormalDialog, TaskAbnormalPointDialog },
  mixins: [TableStripe],
})
export default class Home extends Vue {
  private visible = false;
  private title: any = '隐患排查';
  private total: any = 0;
  private tableData: any = [];
  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
    startDate: null,
    endDate: null,
    patrolStatus: '',
  };
  type: any = 'device';
  rowData: any = {};
  patrolRate: any = '';
  loading: any = false;

  finishOptions: any = [
    { label: '已完成', value: '已完成' },
    { label: '未完成', value: '未完成' },
    { label: '未开始', value: '未开始' },
    { label: '进行中', value: '进行中' },
  ];

  private dateRange: any = [];

  private mounted() {}

  private async showDialog(data: any, flag: any) {
    this.rowData = data;
    this.visible = true;
    if (flag === false) {
      this.queryDataForm.patrolStatus = '未完成';
    } else {
      this.queryDataForm.patrolStatus = '';
    }
    this.dateRange = [Dayjs(new Date()).format('YYYY-MM-DD'), Dayjs(new Date()).format('YYYY-MM-DD')];
    this.type = 'device';
    this.changeFilter();
    this.getRate();
  }

  getData(type: any) {
    this.type = type;
    this.changeFilter();
  }

  changeFilter() {
    this.queryDataForm.pageNo = 1;
    this.queryDataForm.pageSize = 10;
    this.getListData();
  }

  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getListData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getListData();
  }

  getListData() {
    if (this.dateRange && this.dateRange.length) {
      this.queryDataForm.startDate = this.dateRange[0];
      this.queryDataForm.endDate = this.dateRange[1];
    } else {
      this.queryDataForm.startDate = null;
      this.queryDataForm.endDate = null;
    }
    if (this.type === 'point') {
      this.getDataPoint();
    }
    if (this.type === 'device') {
      this.getDataDevice();
    }
  }

  getRate() {
    const form: any = {
      startDate: this.dateRange && this.dateRange.length ? this.dateRange[0] : null,
      endDate: this.dateRange && this.dateRange.length ? this.dateRange[1] : null,
      topDeptId: this.rowData.topDeptId,
    };
    yunnanDataViewServer
      .getPatrolAndDeviceStatistics(form)
      .then((res: any) => {
        this.patrolRate = res.data.total.shouldPatrolNum > 0 ? ((res.data.total.alreadyPatrolNum / res.data.total.shouldPatrolNum) * 100).toFixed(2) : '-';
      })
      .catch((e: any) => {
        console.log(e);
      });
  }

  private getDataPoint() {
    this.loading = true;
    yunnanDataViewServer.getPointPatrolList(this.queryDataForm, { topDeptId: this.rowData.topDeptId }).then((res: any) => {
      this.loading = false;
      const result = res || {};
      if (result.code !== '200') {
        this.$message.warning(result.msg);
      }
      if (result.data) {
        this.tableData = result.data.records;
        this.total = result.data.total;
      }
    });
  }

  private getDataDevice() {
    this.loading = true;
    yunnanDataViewServer.getDevicePatrolList(this.queryDataForm, { topDeptId: this.rowData.topDeptId }).then((res: any) => {
      this.loading = false;
      const result = res || {};
      if (result.code !== '200') {
        this.$message.warning(result.msg);
      }
      if (result.data) {
        this.tableData = result.data.records;
        this.total = result.data.total;
      }
    });
  }

  checkDetail(row: any) {
    if (this.type === 'device') {
      const taskAbnormalDialogComponent: any = this.$refs['taskAbnormalDialog'];
      taskAbnormalDialogComponent.showAddDialog(row);
    }
    if (this.type === 'point') {
      const taskAbnormalDialogComponent: any = this.$refs['taskAbnormalPointDialog'];
      taskAbnormalDialogComponent.showAddDialog(row);
    }
  }

  private hideDialog() {
    this.visible = false;
  }
}
